import './styles/LeaderboardWidget.css';

interface LeaderEntry {
  rank: number;
  name: string;
  score: number;
  avatar: string;
  isYou?: boolean;
}

interface LeaderboardWidgetProps {
  title: string;
  entries: LeaderEntry[];
}

const LeaderboardWidget: React.FC<LeaderboardWidgetProps> = ({ title, entries }) => (
  <div className="lb-widget">
    <div className="lb-widget__header">
      <h4 className="lb-widget__title">Leaderboard</h4>
      <span className="lb-widget__trophy">🏆</span>
    </div>
    <p className="lb-widget__game">{title}</p>
    <div className="lb-widget__list">
      {entries.length === 0 ? (
        <p style={{ textAlign: 'center', color: 'var(--color-text-muted)', padding: '1rem 0', fontSize: '0.85rem' }}>
          No leaderboard data yet. Play a game to get started!
        </p>
      ) : (
        entries.map((e) => (
          <div key={e.rank} className={`lb-widget__row ${e.isYou ? 'lb-widget__row--you' : ''}`}>
            <span className="lb-widget__rank">#{e.rank}</span>
            <span className="lb-widget__avatar">{e.avatar}</span>
            <span className="lb-widget__name">{e.name}</span>
            <span className="lb-widget__score">{e.score.toLocaleString()}</span>
          </div>
        ))
      )}
    </div>
    <button className="lb-widget__view-all">View Full Leaderboard</button>
  </div>
);

export default LeaderboardWidget;
